import { categories } from "@/mocks/categories";

export default function Footer() {
  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10, 14);

  return (
    <footer className="px-4 md:px-6 pb-6 pt-4">
      <div className="max-w-7xl mx-auto bg-foreground-950 rounded-[28px] px-6 md:px-12 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-database-2-line text-white text-sm"></i>
              </span>
              <span className="font-heading text-lg font-bold text-white tracking-tight">
                pandabuy<span className="text-primary-400">.watch</span>
              </span>
            </div>
            <p className="text-sm text-foreground-400 max-w-xs leading-relaxed">
              Your go-to pandabuy spreadsheet resource for curated fashion finds updated daily.
            </p>
          </div>

          <div className="flex flex-wrap gap-8 lg:gap-12">
            <div>
              <h4 className="text-white font-semibold text-sm mb-3">Categories</h4>
              <div className="flex flex-col gap-2">
                {col1.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 text-xs hover:text-white transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-white font-semibold text-sm mb-3">&nbsp;</h4>
              <div className="flex flex-col gap-2">
                {col2.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 text-xs hover:text-white transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-white font-semibold text-sm mb-3">&nbsp;</h4>
              <div className="flex flex-col gap-2">
                {col3.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 text-xs hover:text-white transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:text-right flex-shrink-0">
            <p className="font-heading text-white/90 text-sm mb-4">&copy; 2026 Pandabuy.watch</p>
            <p className="font-heading italic text-2xl md:text-3xl text-foreground-400 leading-snug">
              Curated.<br />Trusted.<br />Updated.
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[11px] text-foreground-500">
            This platform provides informational spreadsheets and curated product discovery content only. We do not sell products directly.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 text-xs hover:text-white transition-colors">
              <i className="ri-global-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}